import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DialogWrapper } from '@common/components/modal/dialog-wrapper';
import Spinner from '@common/components/spinner';
import AccessRequestsItem from './access-requests-item';
import { useAccessRequests } from './use-access-requests';
import { useAccessRequestsContext } from '../../contexts/access-requests-context';

interface Props {
  open: boolean;
  onClose: () => void;
}

const AccessRequestsModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const { selectedChannelId } = useAccessRequestsContext();
  const {
 accessRequests, loading, isActionLoading, handleApprove, handleReject
}
  = useAccessRequests(selectedChannelId || undefined);

  return (
    <DialogWrapper
      show={open}
      onHide={onClose}
      title={t('social:access_requests_modal_title')}
      hideFooter
      content={
        loading ? (
          <Spinner centered size="large" />
        ) : (
          <>
            {accessRequests.length > 0 ? (
              accessRequests.map((accessRequest, index) => (
                <AccessRequestsItem
                  userId={accessRequest.user.id}
                  name={accessRequest.user.full_name}
                  image={accessRequest.user.profile_img}
                  hideBorderBottom={index === accessRequests.length - 1}
                  accessRequestId={accessRequest.id}
                  onApprove={() => handleApprove(accessRequest.id)}
                  onReject={() => handleReject(accessRequest.id)}
                  isActionLoading={isActionLoading}
                />
              ))
            ) : (
              <p className="tw-text-gray-custom-700 tw-text-center tw-mt-[30px]">
                <Trans i18nKey="social:no_access_requests" />
              </p>
            )}
          </>
        )
      }
    />
  );
};

export default AccessRequestsModal;
